import React, { useContext, useState } from "react";
import "./AboutMeRuchi.scss";
import StyleContext from "../../contexts/StyleContext";
import { greeting, socialMediaLinks } from "../../portfolio";
import profilePic from "../../assets/images/me.png";


export default function AboutMeRuchi() {
  const { isDark } = useContext(StyleContext);

  return (
    <section className={`section ${isDark ? "dark-mode" : ""}`} id="home">
      <div className="container">
      <div className="ruchi-about-header">
        <h1 className="typography-headline mb-3">{greeting.title}</h1>
        <p className="section-subtitle mb-5">Data Engineer • Data Storyteller • AI Explorer</p>
      </div>

      <div className="ruchi-main-container">
        <div className="ruchi-left-section">
          <div className="ruchi-profile-image-container">
            <img src={profilePic} alt="Niyanta Pandey" className="ruchi-profile-image" />
          </div>

          <div className="ruchi-social-container">
            <div className="ruchi-social-links">
              {socialMediaLinks.github && (
                <a href={socialMediaLinks.github} className="ruchi-social-icon" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-github"></i>
                </a>
              )}
              {socialMediaLinks.linkedin && (
                <a href={socialMediaLinks.linkedin} className="ruchi-social-icon" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              )}
              {socialMediaLinks.gmail && (
                <a href={`mailto:${socialMediaLinks.gmail}`} className="ruchi-social-icon" target="_blank" rel="noopener noreferrer">
                  <i className="fas fa-envelope"></i>
                </a>
              )}
            </div>
          </div>


        </div>

        <div className="ruchi-right-section">
          <div className="ruchi-section">
            <p className="typography-eyebrow mb-2">About Me</p>
            <div className="ruchi-bio-content">
              <p>
                Over the past 4+ years as a Data Engineer, I've gone from digging into Python and SQL to working with tools like AWS, Databricks, and Apache Kafka. I get a real kick out of building data engineering systems that scale and solve problems—not just for today, but for what's coming down the road.
              </p>
              <p>
                I'm all about making things work smarter, faster, and cleaner—whether it's automating processes, improving data quality, or designing systems that can grow with the business. No matter the challenge, I'm always ready to dive in, learn, and adapt.
              </p>
              <p>
                Right now, I'm balancing hands-on projects with my Master's in Data Analytics and Visualization at Yeshiva University. It's all about learning as I go and staying excited about the new things I can bring into my work. I'm ready to bring my experience, curiosity, and passion for problem-solving to a data engineering team that's pushing the boundaries of what's possible with data.
              </p>
            </div>
          </div>




          </div>
        </div>
      </div>
    </section>
  );
}
